import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class FileService {

  arquivosPermitidosVisualizar: Array<string> = ['png', 'jpg', 'gif', 'jpeg', 'bmp', 'csv', 'xml', 'txt', 'pdf', 'html'];

  constructor () { }

  tamanhoFile (file?: File, size?: number) : Array<number> | null {
    let arrayTam = new Array();
    let tam: number;

    if(file == null) {
      tam = size;
    } else {
      tam = file.size;
    }

    arrayTam['kb'] = tam / 1024;
    arrayTam['mb'] = tam / 1024 / 1024;
    arrayTam['gb'] = tam / 1024 / 1024 / 1024;   

    if (arrayTam['kb'] < 1000) {
      return arrayTam['kb'];
    } else if (arrayTam['mb'] > 1 && arrayTam['mb'] < 1000) {      
      return arrayTam['mb'];
    } else if (arrayTam['gb'] > 1) {    
      return arrayTam['gb'];
    }
    return null;
  }

  unidadeMedida (tam: number) : string | null {
    let tamKb = tam / 1024;
    let tamMb = tam / 1024 / 1024;
    let tamGb = tam / 1024 / 1024 / 1024;

    if (tamKb < 1000) {
      return "kb";
    } else if (tamMb > 1 && tamMb < 1000) {
      return "mb";
    } else if (tamGb > 1) {
      return "gb";
    }
    return null;
  }

  getExtensao (nomeArquivo: any) {    
    if (typeof nomeArquivo === 'undefined') 
      return false;
    return nomeArquivo.slice((nomeArquivo.lastIndexOf(".") - 1 >>> 0) + 2);
  }

  verificaVisualizacaoDocumento (nomeArquivo: string) : boolean {
    if (typeof nomeArquivo !== 'undefined') {
      let nomeParte: Array<string> = nomeArquivo.split('.');
      let ext                      = nomeParte[nomeParte.length - 1].toLowerCase();
      let i                        = this.arquivosPermitidosVisualizar.indexOf(ext);
      if (this.arquivosPermitidosVisualizar[i] == ext)
        return true;
    }        
    return false;
  }

  extensaoTipo (nomeArquivo: string) : Array<any> | null {
    let arrayRe: Array<string> = new Array<string>();

    if (typeof nomeArquivo !== 'undefined') {
      let nomeParte: Array<string> = nomeArquivo.split('.');
      let ext                      = nomeParte[nomeParte.length - 1].toLowerCase();
      let i                        = this.arquivosPermitidosVisualizar.indexOf(ext);

      if (this.arquivosPermitidosVisualizar[i] == ext) {
        switch (ext) {
          case 'png':
            arrayRe.push('imagem');
            arrayRe.push('image/png');
          break;
          case 'jpg':
            arrayRe.push('imagem');
            arrayRe.push('image/jpg');
          break;
          case 'gif':
            arrayRe.push('imagem');
            arrayRe.push('image/gif');
          break;
          case 'jpeg':
            arrayRe.push('imagem');
            arrayRe.push('image/jpeg');
          break;
          case 'bmp':
            arrayRe.push('imagem');
            arrayRe.push('image/bmp');
          break;
          case 'csv':
            arrayRe.push('texto');
            arrayRe.push('application/csv');
          break;
          case 'xml':
            arrayRe.push('texto');
            arrayRe.push('application/xml');
          break;
          case 'txt':
            arrayRe.push('texto');
            arrayRe.push('text/plain');
          break;
          case 'html':
            arrayRe.push('texto');
            arrayRe.push('text/html');
          break;
          case 'pdf':
            arrayRe.push('pdf');
            arrayRe.push('application/pdf');
          break;
          default:
            arrayRe.push('naoreconhecido');
          break;
        }
      }
      arrayRe.push(ext);
    }
    return arrayRe;
  }


}